import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const determineImageType = (width: number, height: number): string => {
  const aspectRatio = width / height;
  if (aspectRatio >= 0.95 && aspectRatio <= 1.05) {
    return 'Carré';
  } else if (aspectRatio > 1.1) {
    return 'Paysage';
  } else if (aspectRatio < 0.9) {
    return 'Portrait';
  }
  return 'Inconnu';
};

/**
 * Renvoie la hauteur du conteneur en fonction du type d'image.
 * @param type - Le type d'image ('Carré', 'Paysage', 'Portrait', 'Inconnu')
 * @returns La hauteur du conteneur en pixels
 */
export const getContainerDimensions = (type: string): { width: number, height: number } => {
  switch (type) {
    case 'Paysage':
      return { width: 290, height: 150 }; // Ajustez la hauteur pour conserver le ratio
    case 'Carré':
      return { width: 290, height: 290 };
    case 'Portrait':
      return { width: 290, height: 400 };
    default:
      return { width: 200, height: 200 }; // Valeur par défaut si le type est inconnu
  }
};